export default "__VITE_ASSET__BGEJkBTa__"